import './Breadcrumb.scss';

import { b2x } from '@b2x/react/src';

export const Breadcrumb = ({ alignment, ...otherProps }: b2x.BreadcrumbProps) => {
  return (
    <b2x.Breadcrumb
      {...otherProps}
      classNameObject={{
        a: 'text-decoration-none',
        component: 'text-uppercase',
        ol: `justify-content-${alignment}`,
      }}
    />
  );
};
